import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Navbar } from "../components/Navbar";
import { HeroSection } from "../components/HeroSection";
import { InstructorCard } from "../components/InstructorCard";
import { CourseAccordion } from "../components/CourseAccordion";
import { PricingCard } from "../components/PricingCard";
import { FooterCTA } from "../components/FooterCTA";
import { useEntitlement } from "../lib/EntitlementContext";
import { useCoursePurchase } from "../lib/useCoursePurchase";

export default function Landing() {
  const navigate = useNavigate();
  const { hasActiveEntitlement, isEntitlementLoading } = useEntitlement();
  const { startPurchase, isPaying, paymentError, paymentMessage } =
    useCoursePurchase();
  const enterStudio = () => navigate("/enter-studio");

  useEffect(() => {
    if (!window.location.hash) return;

    const id = window.location.hash.slice(1);
    window.setTimeout(() => {
      document
        .getElementById(id)
        ?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 0);
  }, []);

  return (
    <div data-testid="landing-page" className="min-h-screen bg-[#050505] text-zinc-100 overflow-x-hidden">
      <Navbar />
      <HeroSection
        onBuy={startPurchase}
        onEnterStudio={enterStudio}
        isPaying={isPaying}
        hasActiveEntitlement={hasActiveEntitlement}
        isEntitlementLoading={isEntitlementLoading}
      />
      <InstructorCard />
      <CourseAccordion
        onUnlock={startPurchase}
        onEnterStudio={enterStudio}
        isPaying={isPaying}
        hasActiveEntitlement={hasActiveEntitlement}
        isEntitlementLoading={isEntitlementLoading}
      />
      <PricingCard
        onBuy={startPurchase}
        onEnterStudio={enterStudio}
        isPaying={isPaying}
        hasActiveEntitlement={hasActiveEntitlement}
        isEntitlementLoading={isEntitlementLoading}
      />
      <FooterCTA
        onBuy={startPurchase}
        onEnterStudio={enterStudio}
        isPaying={isPaying}
        hasActiveEntitlement={hasActiveEntitlement}
        isEntitlementLoading={isEntitlementLoading}
      />
      {(paymentError || paymentMessage) && (
        <div
          role={paymentError ? "alert" : "status"}
          className="fixed bottom-5 left-1/2 z-50 w-[calc(100%-2rem)] max-w-md -translate-x-1/2 rounded-xl border border-white/10 bg-[#0D0D0F]/95 px-5 py-4 text-sm text-zinc-100 shadow-2xl backdrop-blur"
        >
          <p className={paymentError ? "text-red-300" : "text-[#C5A059]"}>
            {paymentError || paymentMessage}
          </p>
        </div>
      )}
    </div>
  );
}
